import React, { useMemo } from 'react';
import { FieldError } from 'react-hook-form';
import { useFetchPartnerPropertiesQuery } from '@@/services/property';
import MultiSelectInput from '@@/components/Inputs/MultiSelectInput';

const SelectPropertiesInput: React.FC<{
  id: string;
  label: string;
  className?: string;
  placeholder?: string;
  error?: FieldError;
  isMulti?: boolean;
  control: any;
}> = ({ id, label, className, placeholder, error, isMulti, control }) => {
  const { data: properties } = useFetchPartnerPropertiesQuery({
    page: 1,
    limit: 100,
  });

  const selectPropertiesInput = useMemo(() => {
    if (properties?.docs) {
      return [...properties.docs]
        .map((property) => ({
          id: String(property.id),
          label: property.name,
        }))
        .sort((c1, c2) => {
          if (c1.label < c2.label) {
            return -1;
          }

          if (c1.label > c2.label) {
            return 1;
          }

          return 0;
        });
    }

    return [];
  }, [properties]);

  if (!properties) {
    return null;
  }

  return (
    <MultiSelectInput
      control={control}
      id={id}
      label={label}
      placeholder={placeholder}
      error={error}
      options={selectPropertiesInput}
      isMulti={isMulti}
      className={className}
    />
  );
};

export default SelectPropertiesInput;
